export default __webpack_public_path__ + "static/media/edge.6d4bb03d.png";